
import store from '@/store';
import { ROLES } from '@/config/permissions';

function canAccessGuard(permissionName) {
  return (to, from, next) => {
    const user = store.state.users?.user || store.getters['users/currentUser'];
    const role = store.state.users?.role;

    if (!user) { location.replace('/login'); return; }

    // allow admins/teachers
    if (role === ROLES.SYSTEMADMINS || user.role?.id === 1 || role === ROLES.SCHOOLADMINS || user.role?.id === 2 || role === ROLES.TEACHERS) {
      return next();
    }

    const permissions = store.state.users?.permissions || [];
    // if permissnion Name is an array 
    if (Array.isArray(permissionName)) {
      return permissionName.some(permission => permissions.includes(permission)) ? next() : next({ path: '/404', replace: true });
    }
    
    if (permissions.includes(permissionName)) return next();

    return next({ path: '/404', replace: true });
  };
}

export default canAccessGuard;
